import { MouseCatcher } from '@naker/services/Catchers/mouseCatcher';
import { ResponsiveCatcher } from '@naker/services/Catchers/responsiveCatcher';
import { ProjectInterface } from '@naker/services/Viewer/viewer';
import { TouchCatcher } from '@naker/services/Catchers/touchCatcher';

import { Particle, particleInterface } from './particle';
import { Environment, environmentInterface } from './environment';
import { coreSystem } from './system';

'use strict';

export let start = (backOptions: backInterface) => {
    return new BackEngine(backOptions);
}

export interface backInterface extends ProjectInterface {
    environment: environmentInterface,
    particle: particleInterface,
}

export class BackEngine {

    system: coreSystem;
    touchCatcher: TouchCatcher;
    mouseCatcher: MouseCatcher;
    responsiveCatcher: ResponsiveCatcher;
    particle: Particle;
    environment: Environment;

    constructor(backOptions: backInterface, system?:coreSystem) {
        if (system) this.system = system;
        else this.system = new coreSystem(backOptions.canvas);
        this.system.setLimitFPS(true);
        this.system.setNeedProcess(false);

        this.touchCatcher = new TouchCatcher(window);
        this.mouseCatcher = new MouseCatcher(this.system, this.touchCatcher);
        this.responsiveCatcher = new ResponsiveCatcher(this.system);
        
        this.particle = new Particle(this.system, backOptions.particle);
        this.environment = new Environment(this.system, this.mouseCatcher, backOptions.environment);
        this.system.launchRender();
    }
}